
function the_estate(){
	var $the_estate 	= $('.the-estate');
	var $hero_image 	= $('.the-estate .hero-image');
	var $estate_slider 	= $('.the-estate-carousel-content');


	initEstateVideos();

	$estate_slider.slick({
		dots: false,
		arrows: true,
		nav: true,
		infinite: true,
		speed: 700,		
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
  		cssEase: 'linear',  		
  		appendDots:$('.the-estate'),
  		appendArrows:$('.the-estate-carousel'),		
		prevArrow: PREV_ARROW,
		nextArrow: NEXT_ARROW,
		responsive: [
    {
      breakpoint: 767,
      settings: {
       	appendArrows:$('.slider-mobile-controls')
      }
    }
  ]
	}); 

	$estate_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){

		$the_estate.addClass('transitioning');
		var $current_slide_id = $the_estate.find('.slick-slide[data-slick-index="'+nextSlide+'"]').data('page-id');		
		$('.the-estate .hero-image .page-'+$current_slide_id).addClass('showing');

	});
	$estate_slider.on('afterChange', function(){
		$the_estate.removeClass('transitioning');			
		var $current_slide = $the_estate.find('.slick-slide.slick-current');		
		var $current_slide_img = $current_slide.data('image');		
		$hero_image.find('.video-bg-container').removeClass('active');
		$hero_image.find('.video-bg-container.showing').addClass('active').removeClass('showing');		
				
	});
}



function initStoresForm(){

	$('select[name="country"]').on('change', function() {
			 	$.ajax({  
			 		data: {
		            module:'stores',
		            action:'get_active_stores_cities',
		            country: $(this).val()
			        },
			        'success': function (response){
			        	$('select[name="city"').html('');
			          	 $.each(response, function(i, value) {
				            $('select[name="city"').append($('<option>').text(value.city.trim().toUpperCase()).attr('value', value.city.trim()));
				        });
			          	
			        }
		        });
			});

	 $('.stores-form').validate({
        submitHandler: function() {
            var data = $('.stores-form').serialize();
            console.log(data);
            var object = {
                'success': function (response){
                   $('.stores-list-wrapper').html(response);

                },
                url: URL + "ajax/staticblocks:stores/?"+data,
                dataType: 'html'
            };
            $.ajax(object);
            return false;
        },
        errorPlacement: function(error, element) {
            // error.hide();
        }
        
    });

	
}